import { CLINIC } from "../../lib/clinic";
import { MessageCircle } from "lucide-react";
import { trackEvent } from "../../lib/analytics";

export default function WhatsAppButton() {
  const url = `https://wa.me/${CLINIC.whatsappRaw}?text=${encodeURIComponent("Olá! Gostaria de marcar uma consulta no Instituto Clínico do Barlavento.")}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackEvent("click_whatsapp", { source: "floating" })}
      data-testid="whatsapp-float-button"
      aria-label="Contactar via WhatsApp"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
      <span className="relative w-14 h-14 inline-flex items-center justify-center rounded-full bg-[#25D366] text-white shadow-xl shadow-green-500/30 hover:scale-110 transition-transform">
        <MessageCircle size={26} />
      </span>
      <span className="hidden md:block absolute right-16 top-1/2 -translate-y-1/2 bg-white text-brand-500 text-sm font-medium px-3 py-2 rounded-md shadow-lg opacity-0 group-hover:opacity-100 transition whitespace-nowrap">
        WhatsApp: {CLINIC.whatsapp}
      </span>
    </a>
  );
}
